import {
  ConfigureOptionsParams,
  FilterOptions,
  FilterPassParams
} from '../filter-types';
import { CalendarGridColumnName } from '../../../grid/types/column.types';
import { convertToStringArray } from '../filter-utils';
import { dealTypeValueGetter } from '../../../grid/utils/value-getters/deal-type';
import { InclusiveExclusiveFilterHandler } from './base/inclusive-exclusive-filter-handler';

export class TypeFilterHandler extends InclusiveExclusiveFilterHandler {
  protected getValue(params: FilterPassParams): string[] {
    return dealTypeValueGetter({ data: params.deal });
  }

  get name(): CalendarGridColumnName {
    return CalendarGridColumnName.Type;
  }

  configureFilterOptions(params: ConfigureOptionsParams): void {
    params.setFilterService.type = params.filterOptions.type;
  }

  getFilterOptions(filterOptions: FilterOptions): string[] {
    return convertToStringArray(filterOptions.type);
  }
}
